import { render } from "./system-dashboard.vue?vue&type=template&id=09e3dcae&ts=true"
import script from "./system-dashboard.vue?vue&type=script&lang=ts"
export * from "./system-dashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__